// Numeric values
export const numericPercentages = {
  30: "30%",
  40: "40%",
  50: "50%",
  75: "75%",
  90: "90%",
  100: "100%",
};

export const numericMilliseconds = {
  100: "100ms",
  200: "200ms",
  300: "300ms",
  400: "400ms",
  500: "500ms",
};

export const numericPixels = {
  [-48]: "-48px",
  [-32]: "-32px",
  [-20]: "-20px",
  [-16]: "-16px",
  [-10]: "-10px",
  [-8]: "-8px",
  [-5]: "-5px",
  0: "0px",
  1: "1px",
  2: "2px",
  3: "3px",
  4: "4px",
  5: "5px",
  6: "6px",
  8: "8px",
  10: "10px",
  12: "12px",
  14: "14px",
  15: "15px",
  16: "16px",
  18: "18px",
  20: "20px",
  22: "22px",
  24: "24px",
  25: "25px",
  26: "26px",
  28: "28px",
  30: "30px",
  32: "32px",
  36: "36px",
  40: "40px",
  46: "46px",
  48: "48px",
  52: "52px",
  56: "56px",
  64: "64px",
  68: "68px",
  72: "72px",
  80: "80px",
  96: "96px",
  100: "100px",
  104: "104px",
  106: "106px",
  112: "112px",
  120: "120px",
  136: "136px",
  138: "138px",
  144: "144px",
  156: "156px",
  160: "160px",
  180: "180px",
  200: "200px",
  218: "218px",
  226: "226px",
  240: "240px",
  250: "250px",
  260: "260px",
  300: "300px",
  320: "320px",
  360: "360px",
  400: "400px",
  480: "480px",
  520: "520px",
  560: "560px",
  600: "600px",
  640: "640px",
  720: "720px",
  777: "777px",
  784: "784px",
  888: "888px",
  984: "984px",
  999: "999px",
  1070: "1070px",
};

export const numericViewportWidth = {
  40: "40dvw",
  50: "50dvw",
  70: "70dvw",
  90: "90dvw",
  100: "100dvw",
};

export const numericViewportHeight = {
  20: "20dvh",
  50: "50dvh",
  80: "80dvh",
  100: "100dvh",
};

export const numericValues = {
  "0.5": "0.5",
  "0.6": "0.6",
  0: "0",
  400: "400",
  600: "600",
  700: "700",
  800: "800",
};

// Design tokens
export const dropShadow = {
  none: numericValues[0],
  xs: numericPixels[2],
  s: numericPixels[4],
  ms: numericPixels[8],
  m: numericPixels[16],
  ml: numericPixels[24],
  l: numericPixels[48],
};

export const spacingMasks = {
  xxs: numericPixels[24],
  xs: numericPixels[32],
  s: numericPixels[56],
  m: numericPixels[80],
  l: numericPixels[160],
  xl: numericPixels[240],
};

export const radius = {
  /** 0px */
  none: numericValues[0],
  /** 2px */
  xxs: numericPixels[2],
  /** 4px */
  xs: numericPixels[4],
  /** 8px */
  s: numericPixels[8],
  /** 12px */
  ms: numericPixels[12],
  /** 16px */
  m: numericPixels[16],
  /** 20px */
  l: numericPixels[24],
  /** 32px */
  xl: numericPixels[32],
  /** 999px */
  full: numericPixels[999],
};

export const spacing = {
  negativeXXL: numericPixels[-48],
  negativeXL: numericPixels[-32],
  negativeM: numericPixels[-16],
  negativeS: numericPixels[-8],
  none: numericValues[0],
  /** 2px of space */
  t: numericPixels[2],
  /** 4px of space */
  xxs: numericPixels[4],
  /** 6px of space */
  xs: numericPixels[6],
  /** 8px of space */
  s: numericPixels[8],
  /** 12px of space */
  ms: numericPixels[12],
  /** 16px of space */
  m: numericPixels[16],
  /** 20px of space */
  ml: numericPixels[20],
  /** 24px of space */
  l: numericPixels[24],
  /** 32px of space */
  xl: numericPixels[32],
  /** 48px of space */
  xxl: numericPixels[48],
  /** 48px — height of the bottom menu bar on mobile */
  bottomMenuBarMobile: numericPixels[48],
  /** 64px of space */
  xxxl: numericPixels[64],
  fit: "fit-content",
  full: numericPercentages[100],
  /** 90 height + 24 spacing at bottom + 24 more at top for good measure */
  mediaPlayerDesktop: numericPixels[138],
  mediaPlayerMobile: numericPixels[218], // + bottom menu bar
  /** 64 height + 64 spacing at bottom + 16 more at top */
  mediaPlayerWithoutMenuBarMobile: numericPixels[144],
  minContent: "min-content",
  sidebar: numericPixels[320],
  collapsedSidebar: numericPixels[72],
  maxReaderWidth: numericPixels[720],
  maxWidth: numericPixels[888],
  maxWidthWithPaddingXS: numericPixels[520],
  maxWidthWithPaddingS: numericPixels[640],
  maxWidthWithPaddingMS: numericPixels[784],
  maxWidthWithPaddingM: numericPixels[984],
  maxWidthWithPaddingL: numericPixels[1070],
  footer: numericPixels[80],
};

export const stroke = {
  none: numericPixels[0],
  light: numericPixels[1],
  regular: numericPixels[2],
  heavy: numericPixels[4],
};

// Typography
export const fontFamilies = {
  sansSerif: "Twemoji Country Flags, Hallow Moderat, sans-fallback, sans-serif",
  serif: "Twemoji Country Flags, Hallow Moderat Serif, serif-fallback, serif",
};

export const fontSizes = {
  bodyS: numericPixels[14],
  bodyM: numericPixels[16],
  bodyL: numericPixels[18],
  bodyXL: numericPixels[24],
  bodyBible: numericPixels[20],
  buttonXS: numericPixels[12],
  buttonS: numericPixels[14],
  buttonM: numericPixels[16],
  buttonL: numericPixels[18],
  detailS: numericPixels[8],
  detailM: numericPixels[10],
  detailL: numericPixels[12],
  detailXL: numericPixels[14],
  displayS: numericPixels[40],
  displayM: numericPixels[48],
  displayL: numericPixels[56],
  headlineS: numericPixels[24],
  headlineM: numericPixels[28],
  headlineL: numericPixels[32],
  quoteM: numericPixels[18],
  quoteL: numericPixels[20],
  quoteXL: numericPixels[24],
  titleXS: numericPixels[12],
  titleS: numericPixels[14],
  titleM: numericPixels[16],
  titleL: numericPixels[20],
  titleXL: numericPixels[22],
  tosS: numericPixels[16],
  tosM: numericPixels[20],
  tosL: numericPixels[28],
};

export const fontWeights = {
  bodyS: numericValues[400],
  bodyM: numericValues[400],
  bodyL: numericValues[400],
  bodyXL: numericValues[400],
  bodyBible: numericValues[400],
  buttonXS: numericValues[600],
  buttonS: numericValues[700],
  buttonM: numericValues[700],
  buttonL: numericValues[700],
  detailS: numericValues[400],
  detailM: numericValues[400],
  detailL: numericValues[400],
  detailXL: numericValues[400],
  displayS: numericValues[800],
  displayM: numericValues[800],
  displayL: numericValues[800],
  headlineS: numericValues[800],
  headlineM: numericValues[800],
  headlineL: numericValues[800],
  quoteM: numericValues[400],
  quoteL: numericValues[400],
  quoteXL: numericValues[400],
  titleXS: numericValues[600],
  titleS: numericValues[700],
  titleM: numericValues[700],
  titleL: numericValues[700],
  titleXL: numericValues[700],
};

export const lineHeights = {
  bodyS: numericPixels[18],
  bodyM: numericPixels[20],
  bodyL: numericPixels[22],
  bodyXL: numericPixels[28],
  bodyBible: numericPixels[28],
  buttonXS: numericPixels[16],
  buttonS: numericPixels[18],
  buttonM: numericPixels[20],
  buttonL: numericPixels[22],
  detailS: numericPixels[10],
  detailM: numericPixels[14],
  detailL: numericPixels[16],
  detailXL: numericPixels[18],
  displayS: numericPixels[48],
  displayM: numericPixels[56],
  displayL: numericPixels[64],
  headlineS: numericPixels[32],
  headlineM: numericPixels[32],
  headlineL: numericPixels[40],
  quoteM: numericPixels[22],
  quoteL: numericPixels[24],
  quoteXL: numericPixels[32],
  titleXS: numericPixels[14],
  titleS: numericPixels[18],
  titleM: numericPixels[20],
  titleL: numericPixels[24],
  titleXL: numericPixels[26],
};

// Z-indices
export const zIndices = {
  behind: -1,
  1: 1,
  2: 2,
  3: 3,
  padTitle: 1,
  padReportedOverlay: 1,
  padToast: 2,
  absolute: 5,
  mask: 10,
  maskOver: 11,
  overlayUnderMenuBar: 44,
  modalUnderMenuBar: 45,
  menuBar: 50,
  games: 60,
  closeOverGames: 61,
  transcript: 69,
  modalOverTranscript: 70,
  mediaPlayer: 70,
  overlayOverMediaPlayer: 71,
  modalOverMediaPlayer: 72,
  queueContent: 73,
  modalOverQueue: 74,
  modalOverlay: 90,
  modalContent: 91,
  overlayOverModal: 92,
  modalOverModal: 92,
  modalOverModalOverModal: 93,
  dropdownOverModal: 95,
  overlayCommunitySelector: 96,
  modalContentCommunitySelector: 97,
  tooltip: 100,
  /** Above an app's fixed CTA footer, which those apps layer at 100 */
  overlayOverFixedFooter: 101,
  modalOverFixedFooter: 102,
  scrollbar: 998,
  toast: 999,
  loading: 1000,
};
